var filter = function() {
  return function(input) {
    if (input == null || input == undefined || input == 0 || isNaN(input)) { return 'N/A'; }
    return formatWithDecimal(input);
  };
};

filter.$inject = [];
tiz.filter('money', filter);

var filter2 = function() {
  return function(input) {
    if (input == null || input == undefined || input == 0) { return ''; }
    return formatWithDecimal(input);
  };
};

filter2.$inject = [];
tiz.filter('money2', filter2);

var filter3 = function() {
  return function(input) {
    return '$' + parseFloat(input).toFixed(0);
  };
};

filter3.$inject = [];
tiz.filter('money3', filter3);

var filter4 = function() {
  return function(input) {
    if (input == null || input == undefined || input == 0) { return 'Free'; }
    return formatWithDecimal(input);
  };
};

filter4.$inject = [];
tiz.filter('moneyOrFree', filter4);

// for svelte = always show decimals
var filter5 = function() {
  return function(input) {
    if (input == null || input == undefined || input == 0) { return '$0.00'; }
    return formatWithDecimal(input);
  };
};

var formatWithDecimal = function(input) {
  if (!window.Intl) {
    // fallback for when the polyfill does not work
    return '$' + parseFloat(input).toFixed(2).replace(/\.00$/,'');
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formatter.format(input);
}

export default {
  filter: filter,
  filter2: filter2,
  filter3: filter3,
  filter4: filter4,
  filter5: filter5,
  formatWithDecimal
}
